export default __webpack_public_path__ + "static/Silencer_Attachment-1555e0e5db8eb69fdb2215f092eeb713.png";